import { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: "17c一起草国是什么样的平台？",
    answer: "17c一起草国是一个优质内容分享平台，我们汇聚了各领域的精选文章和原创内容。无论你是想获取最新资讯、学习实用技能，还是寻找深度阅读体验，在这里都能找到适合你的内容。我们的编辑团队每天精选优质内容，确保每一篇文章都值得你的时间。",
  },
  {
    question: "如何找到我感兴趣的内容？",
    answer: "你可以通过首页的分类导航快速进入感兴趣的领域。我们提供六大内容分类：热门推荐、最新资讯、深度解读、精品原创、教程指南和互动讨论。每个分类下都有精心整理的文章列表，点击即可开始阅读。此外，首页的热门推荐区域会展示当前最受欢迎的内容。",
  },
  {
    question: "平台上的内容是否免费？",
    answer: "是的，17c一起草国上的所有内容均免费开放阅读。我们致力于让优质内容触手可及，降低知识获取的门槛。你无需注册或付费即可畅读平台上的所有文章。未来我们可能会推出会员专属内容，但基础阅读服务将始终保持免费。",
  },
  {
    question: "我可以投稿自己的文章吗？",
    answer: "当然可以！我们非常欢迎优秀创作者加入。你可以通过关于我们页面提供的联系方式投稿。投稿文章经编辑审核通过后，将在相应分类中展示。我们鼓励原创、深度、有价值的内容创作，并为优质作者提供流量支持和展示机会。",
  },
  {
    question: "如何在手机上获得更好的阅读体验？",
    answer: "17c一起草国采用响应式设计，在手机、平板和电脑上都能获得良好的阅读体验。你只需要使用手机浏览器访问我们的网站，页面会自动适配你的屏幕尺寸。我们建议在Wi-Fi环境下阅读以获得更流畅的加载体验。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于17c一起草国，你可能想知道的
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === idx ? "ri-subtract-line" : "ri-add-line"
                  }`}
                />
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}